export class OrgImportData
{
    Staff: StaffImportData[];
    Classes: string[];
    Students: StudentImportData[]
}

export class StaffImportData
{
    class: string | null;
    name: string;
    email: string;
    role: string;
}

export class StudentImportData
{
    class: string;
    name: string;
    externalId: string;
    courseCode: string;
    parentName: string | null;
    parentEmail: string | null;
    studentGrade: string | null;
}